
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Star, Users, CheckCircle2 } from "lucide-react";
interface TasksListProps {
  uniqueTaskIds: string[];
  selectedTaskId: string | null;
  onTaskSelect: (taskId: string) => void;
  getAssignmentsForTask: (taskId: string) => any[];
  isLoading: boolean;
  fullHeight?: boolean;
}

const TasksList = ({
  uniqueTaskIds,
  selectedTaskId,
  onTaskSelect,
  getAssignmentsForTask,
  isLoading,
  fullHeight = false
}: TasksListProps) => {
  return (
    <Card className={`w-80 bg-secondary/50 backdrop-blur-lg border-primary border ${fullHeight ? 'h-full flex flex-col' : ''}`}>
      <CardHeader className="pb-3 flex-shrink-0">
        <CardTitle className="text-white text-lg flex items-center gap-2">
          Project Tasks
          <span className="text-xs text-green-300">✅ OPTIMIZED</span>
        </CardTitle>
      </CardHeader>
      <CardContent className={fullHeight ? 'flex-1 overflow-y-auto scrollbar-thin min-h-0' : 'max-h-[560px] overflow-y-auto scrollbar-thin'}>

        {uniqueTaskIds.length === 0 ? (
          <div className="text-center py-4">
            <Users className="h-12 w-12 text-gray-400 mx-auto mb-3" />
            <p className="text-gray-300">No project tasks found</p>
            <p className="text-xs text-blue-300 mt-2">
              💡 Tasks are loaded from the project structure
            </p>
          </div>
        ) : (
          <div className="space-y-1">
            <div className="text-[9px] text-blue-300 mb-3 p-2 bg-blue-900/20 rounded border border-blue-500/30">
              {uniqueTaskIds.length} tasks loaded from project structure. 
              Click a task to load its resource assignments.
            </div>
            
            {uniqueTaskIds.map((taskId, index) => (
              <div
                key={taskId}
                onClick={() => onTaskSelect(taskId)}
                className={`p-3 rounded-lg cursor-pointer transition-all duration-200 ${
                  selectedTaskId === taskId
                    ? 'bg-primary/20 border-2 border-white text-primary'
                    : 'bg-secondary/30 border border-primary/30 text-gray-300 hover:bg-secondary/50'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="text-[10px] text-primary mb-1">{taskId}</div>
                    <div className="text-[9px] opacity-75">
                      {selectedTaskId === taskId ? (
                        isLoading ? (
                          <span className="flex items-center gap-1">
                            <div className="animate-spin h-3 w-3 border border-primary border-t-transparent rounded-full"></div>
                            Loading assignments...
                          </span>
                        ) : (
                          <span className="flex items-center gap-1 text-[9px]">
                            {getAssignmentsForTask(taskId).length} resources loaded
                          </span>
                        )
                      ) : (
                        `Task ${index + 1} - Click to load assignments`
                      )}
                    </div>
                  </div>
                  
                  {selectedTaskId === taskId && (
                    <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TasksList;
